import styled from 'styled-components';
import type { BlockProps } from '../../lib/card';
import { CardLayout } from '../../lib/card';
import { Text, Title } from '../../lib/components';
import { usePost } from '../Post';
import { usePostSettings } from '../utils';

interface CardTextBlockProps extends BlockProps {
  grow?: boolean;
  disableControl?: boolean;
  centered?: boolean;
}

export function CardTextBlock({
  grow,
  disableControl = false,
  centered = false,
  ...forwardingProps
}: CardTextBlockProps) {
  const { showText, heightNormalization } = usePostSettings();
  const {
    horizontal,
    title,
    hasRepost,
    text = '',
    showTextLink,
    isReadMoreRendered
  } = usePost();

  const display = showText && (title || text);

  const shouldGrow =
    showTextLink || horizontal
      ? heightNormalization && isReadMoreRendered
      : heightNormalization;

  if (!display && heightNormalization && !hasRepost) {
    return <TextPlaceholder />;
  }

  if (!display) {
    return null;
  }

  return (
    <CardLayout.Block
      {...forwardingProps}
      _column
      _center={centered || horizontal}
      _grow={shouldGrow || grow}
    >
      <Title centered={centered} />

      <Text
        text={text}
        align={centered ? 'center' : 'left'}
        disableControl={disableControl}
      />
    </CardLayout.Block>
  );
}

const TextPlaceholder = styled.div`
  flex-grow: 1;
`;
